import type { Keyframe, SavedKeyframeRow } from './types';
import { formatVector3String } from '@/utils/numberUtils';

/**
 * The saved row of a keyframe the editor holds, for a renderer message (keyframeUpdated on a resync): the
 * renderer requires every field the saved row has, createdAt among them, so it comes along from the store.
 */
export function keyframeRowOf(keyframe: Keyframe): SavedKeyframeRow {
  const row: SavedKeyframeRow = {
    keyframe_id: keyframe.id,
    keyframe_time: keyframe.timePosition,
    asset_instance_id: keyframe.assetInstanceId,
    scene_instance_id: keyframe.sceneInstanceId,
    // A keyframe made in this session holds no createdAt until it is read back; the renderer requires one
    created_at: keyframe.createdAt ?? new Date().toISOString(),
  };
  if (keyframe.category !== undefined) row.keyframe_category = keyframe.category;
  // "x,y,z", as the row stores them
  if (keyframe.position !== undefined) row.keyframe_position = formatVector3String(keyframe.position, 3);
  if (keyframe.rotation !== undefined) row.keyframe_rotation = formatVector3String(keyframe.rotation, 3);
  if (keyframe.scale !== undefined) row.keyframe_scale = formatVector3String(keyframe.scale, 3);
  return row;
}
